import React, { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import Root from "../../Root";
import LoaderScreen from "../../components/loaders/LoaderScreen";
import PageWrapper from "../../layouts/PageWrapper";
import ProtectedRoute from "./guards/ProtectedRoute";
import PublicRoute from "./guards/PublicRoute";

const LandingPage = lazy(() => import("../../features/landing/pages/LandingPage"));
const LoginPage = lazy(() => import("../../features/auth/pages/LoginPage"));
const DashboardLayout = lazy(
  () => import("../../features/dashboard/layouts/DashboardLayout")
);
const HomePage = lazy(() => import("../../features/dashboard/pages/HomePage"));

// ── Módulo de Compras ─────────────────────────────────────────────────────────
const MyDocumentsPage      = lazy(() => import("../../features/purchases/pages/MyDocumentsPage"));
const PurchaseOrdersPage   = lazy(() => import("../../features/purchases/pages/PurchaseOrdersPage"));
const PurchaseRequestsPage = lazy(() => import("../../features/purchases/pages/PurchaseRequestsPage"));

// ── Módulo de Cuentas ─────────────────────────────────────────────────────────
const ProviderDebtPage  = lazy(() => import("../../features/current-accounts/pages/ProviderDebtPage"));
const PaymentOrdersPage = lazy(() => import("../../features/current-accounts/pages/PaymentOrdersPage"));

// ── Módulo Catálogos ──────────────────────────────────────────────────────────
const SuppliesPage   = lazy(() => import("../../features/catalogs/pages/SuppliesPage"));
const SuppliersPage  = lazy(() => import("../../features/catalogs/pages/SuppliersPage"));
const ServicesPage   = lazy(() => import("../../features/catalogs/pages/ServicesPage"));
const FamiliasPage   = lazy(() => import("../../features/catalogs/pages/FamiliasPage"));
const SubFamiliasPage= lazy(() => import("../../features/catalogs/pages/SubFamiliasPage"));
const TiposDocumentoPage = lazy(() => import("../../features/catalogs/pages/TiposDocumentoPage"));

// ── Módulo de Procesos ────────────────────────────────────────────────────────
const WarehouseRequisitionsPage = lazy(() => import("../../features/processes/pages/WarehouseRequisitionsPage"));
const WarehouseTransfersPage    = lazy(() => import("../../features/processes/pages/WarehouseTransfersPage"));
const AreaExitsPage             = lazy(() => import("../../features/processes/pages/AreaExitsPage"));
const IngredientPortioningPage  = lazy(() => import("../../features/processes/pages/IngredientPortioningPage"));

// ── Módulo de Kardex ──────────────────────────────────────────────────────────
const MainWarehouseKardexPage = lazy(() => import("../../features/kardex/pages/MainWarehouseKardexPage"));
const SubWarehouseKardexPage  = lazy(() => import("../../features/kardex/pages/SubWarehouseKardexPage"));

const suspense = (children: React.ReactNode) => (
  <React.Suspense fallback={<LoaderScreen />}>{children}</React.Suspense>
);

export const appRouter = createBrowserRouter([
  {
    element: <Root />,
    children: [
      {
        element: <PublicRoute />,
        children: [
          {
            path: "/",
            element: (
              <PageWrapper direction="left">
                {suspense(<LandingPage />)}
              </PageWrapper>
            ),
          },
          {
            path: "/login",
            element: (
              <PageWrapper direction="left">
                {suspense(<LoginPage/>)}
              </PageWrapper>
            ),
          },
        ],
      },
      {
        element: (
          <ProtectedRoute>
            {suspense(<DashboardLayout />)}
          </ProtectedRoute>
        ),
        children: [
          {
            path: "dashboard",
            element: suspense(<HomePage/>),
          },
          // {
          //   path: "menu/inicio",
          //   element: suspense(<HomePage/>),
          // },
          {
            path:"compras/mis-documentos",
            element:suspense(<MyDocumentsPage/>),
          },
          {
            path:"compras/solicitudes-de-compra",
            element:suspense(<PurchaseRequestsPage/>),
          },
          {
            path:"compras/ordenes-de-compra",
            element:suspense(<PurchaseOrdersPage/>),
          },
          {
            path: "cuentas/proveedores",
            element: suspense(<ProviderDebtPage />),
          },
          {
            path: "menu/cuentas",
            element: suspense(<ProviderDebtPage />),
          },
          {
            path: "cuentas/ordenes-de-pago",
            element: suspense(<PaymentOrdersPage />),
          },
          {
            path: "menu/ordenes-de-pago",
            element: suspense(<PaymentOrdersPage />),
          },
          {
            path: "menu/mis-insumos",
            element: suspense(<SuppliesPage />),
          },
          {
            path: "menu/mis-servicios",
            element: suspense(<ServicesPage />),
          },
          {
            path: "menu/mis-proveedores",
            element: suspense(<SuppliersPage />),
          },
          {
            path: "menu/familias",
            element: suspense(<FamiliasPage />),
          },
          {
            path: "menu/subfamilias",
            element: suspense(<SubFamiliasPage />),
          },
          {
            // Ruta enrutada pero sin entrada en el sidebar: la gestión de
            // tipos de documento todavía está pensada para terminar de implementarse.
            path: "menu/tipos-documento",
            element: suspense(<TiposDocumentoPage />),
          },
          // ── Procesos de Almacenes ───────────────────────────────────────────
          {
            path: "procesos/requerimientos",
            element: suspense(<WarehouseRequisitionsPage />),
          },
          {
            path: "procesos/transferencias",
            element: suspense(<WarehouseTransfersPage />),
          },
          {
            path: "procesos/salidas",
            element: suspense(<AreaExitsPage />),
          },
          {
            path: "procesos/porcionamiento",
            element: suspense(<IngredientPortioningPage />),
          },
          // ── Kardex ──────────────────────────────────────────────────────────
          {
            path: "kardex/central",
            element: suspense(<MainWarehouseKardexPage />),
          },
          {
            path: "kardex/subalmacenes",
            element: suspense(<SubWarehouseKardexPage />),
          },
        ],
      },
    ],
  },
]);
